import { useSelect } from "@refinedev/antd";
import { ICategory } from "interfaces";
import { APP_WRITE_CATEGORY_ID } from "utility/constants";

export const CategorySelectOptions = () => {
  const { selectProps: categorySelectProps } = useSelect<ICategory>({
    resource: APP_WRITE_CATEGORY_ID,
    optionLabel: "Name",
    optionValue: "id",
    sorters: [
        {
            field: "Name",
            order: "asc",
        },
    ],
});
  return (
    {categorySelectProps}
  );
};